import { RestService } from '../rest';
import { KcasTokenVerificationFieldType, KcasTokenVerificationFieldKey, } from './types/KcasTokenVerification';
const restService = new RestService();
export const setJwt = (token) => {
    restService.setToken(token);
};
export const getCognitoEnvironment = () => {
    return restService.http.get('/api/cognito/environment');
};
export const getConsumerStatus = () => {
    return restService.http.get('/api/kloans-authentication/consumer/status');
};
export const postConsumerStatus = (request) => {
    return restService.http.post('/api/kloans-authentication/consumer/status', request);
};
export const postForgotUsername = (request) => {
    return restService.http.post('/api/kloans-authentication/forgotUsername', request);
};
export const postForgotPassword = (request) => {
    return restService.http.post('/api/kloans-authentication/forgotPassword', request);
};
export const postResetPassword = (request) => {
    return restService.http.post('/api/kloans-authentication/confirmForgotPassword', request);
};
export const getKcasEnrollmentValidateToken = (params) => {
    return restService.http.get(`/api/kcas/enrollment/token/validate/${params.token}`);
};
export const postKcasEnrollmentVerifyTokenData = (token, payload) => {
    const requestBody = payload ? [
        {
            key: KcasTokenVerificationFieldKey.SSN_LAST_4,
            value: payload.ssnLast4,
            validationFieldType: KcasTokenVerificationFieldType.SSN_LAST_4,
        },
        {
            key: KcasTokenVerificationFieldKey.DOB,
            value: payload.dateOfBirth,
            validationFieldType: KcasTokenVerificationFieldType.DOB,
        },
    ] : undefined;
    return restService.http.post(`/api/kcas/enrollment/token/verify-token-data/${token}`, requestBody);
};
export const postEnrollmentValidateToken = (params, request) => {
    return restService.http.post(`/api/kloans-consumer/consumer/validate/${params.token}`, request);
};
export const postUsernameAvailability = (request) => {
    return restService.http.post('/api/kloans-authentication/username', request);
};
export const postCreateUser = (request) => {
    return restService.http.post('/api/kloans-authentication/user', request);
};
export const postConfirmUser = (request) => {
    return restService.http.post('/api/kloans-authentication/confirmSignUp', request);
};
export const postResendConfirmationCode = (request) => {
    return restService.http.post('/api/kloans-authentication/resendConfirmationCode', request);
};
export const putUpdatePhone = (request, headers) => {
    return restService.http.put('/api/kcas/profile/profile/update-phone-kjwt', request, { headers });
};
export const postCreatePin = (request) => {
    return restService.http.post('/api/kloans-authentication/pin', request);
};
export const postEnrollmentResume = (request) => {
    return restService.http.post('/api/kloans-authentication/resume-enrollment', request);
};
export const postMortgageLinkEmail = (request) => {
    return restService.http.post('/api/v1/mortgage/update-email', request);
};
export const getSession = () => {
    return restService.get('/api/session');
};
